import AbstractDataBuilder from "../../core/AbstractDataBuilder";
import SelectPromotionNormalizersResolver from "./SelectPromotionNormalizersResolver";
export default class SelectPromotionDataBuilder extends AbstractDataBuilder {
    static create() {
        if (undefined === this.builderInstance) {
            this.builderInstance = new this(new SelectPromotionNormalizersResolver());
        }
        return this.builderInstance;
    }
}
